module.exports = __webpack_public_path__ + "img/serum-card-fr.601e1b7e.jpg";